'use client';

import { RedListCategoriesChartIsland } from '@/components/charts/RedListCategoriesChartIsland';
import { GA_CHART_ID } from '@/constants/analytics';

import {
  StateDonutChartChrome,
  useStateDonutChartFilters,
} from './StateDonutChartChrome';

import type { Messages } from '@/content/messages';
import type { Locale } from '@/lib/i18n';
import type { ReactNode } from 'react';

type RedListCategoriesChromeProps = {
  locale: Locale;
  charts: Messages['state']['charts'];
  chartHeader: ReactNode;
};

function RedListCategoriesChartSlot({
  locale,
  charts,
}: {
  locale: Locale;
  charts: Messages['state']['charts'];
}) {
  const {
    displayViewMode,
    flywayFilter,
    phase,
    onExitComplete,
    onEnterComplete,
  } = useStateDonutChartFilters();

  return (
    <RedListCategoriesChartIsland
      locale={locale}
      viewMode={displayViewMode}
      flywayFilter={flywayFilter}
      phase={phase}
      onExitComplete={onExitComplete}
      onEnterComplete={onEnterComplete}
      centerDescriptor={charts.redListCategories.centerDescriptor}
      ariaLabel={charts.redListCategories.ariaLabel}
      speciesGroupLabels={charts.speciesGroups}
      habitatLabels={charts.habitats}
      categoryLabels={charts.redListCategories.categoryLabels}
    />
  );
}

/**
 * Client island for Red List Categories: wires shared chrome to the chart.
 */
export function RedListCategoriesChrome({
  locale,
  charts,
  chartHeader,
}: RedListCategoriesChromeProps) {
  return (
    <StateDonutChartChrome
      chartId={GA_CHART_ID.redListCategories}
      heading={charts.redListCategories.heading}
      charts={charts}
      datazoneUrl={charts.redListCategories.datazoneUrl}
      chartHeader={chartHeader}
    >
      <RedListCategoriesChartSlot locale={locale} charts={charts} />
    </StateDonutChartChrome>
  );
}
